export enum SearchResultPage {
  DEFAULT = 'default',
  SUPPORT = 'support'
}

export interface SearchV3Result {
  term: string;
  label?: string;
  count?: number;
  redirectUrl: string;
}

export interface SearchV3SupportResult {
  term: string;
  redirectUrl?: string;
}

export interface SearchV3PopularSearchResult {
  term: string;
  click?: number;
  queries?: number;
}

export interface SearchTermRedirects {
  redirects?: Array<{
    searchTerm: string;
    target: string;
    catalog: string;
  }>;
}
